module.exports = __webpack_public_path__ + "static/media/navImg.2b3c4ffb.svg";